export interface RatingSelectionDraft {
  debitsOverride: number | null;
  uwDollars: number | null;
  irixSource: boolean;
  notes: string;
}

export const EMPTY_SELECTION_DRAFT: RatingSelectionDraft = { debitsOverride: null, uwDollars: null, irixSource: false, notes: "" };
